/* WL site search v1 — header magnify dropdown (2026-07-31).
   ONE search for the whole site: artworks + murals/tools + collections + pages
   + FAQ + journal. Lives inside the theme's header-search dialog (snippet
   snippets/header-search.liquid keeps the Prestige dialog shell + input; the
   Shopify <predictive-search> component is removed — this module owns the input).
   Tiers: typing = instant lexical (free, /api/site-search); Enter = deep search
   (one embedding call, same endpoint, deep:true). Full artwork dives continue at
   /collections/all?wlq=… (wl_bar.js reads wlq — the existing art search hub).
   Design: Google-restraint on the theme's own type scale — no new colours, no
   pills; matched words bolded, keyboard ↑↓ + Enter, groups under h6 headings.
   Served from R2 app/search.js. */
(function () {
  var API = "https://wl-studio.wallliberation.workers.dev";
  // Source memory (attribution build, Summer's yes 2026-08-28). It lives HERE
  // because wl-search.js is the one module every page loads (home, cart,
  // pages/*, collections, PDP) — wl-bar.js is absent on home/cart/pages, and a
  // homepage landing would lose its referrer before the bar ever ran.
  // Remembers the FIRST visit — referrer, landing page, utm tags — under an
  // anonymous session id (random code, no name, no email). Never overwritten.
  // One "visit" ping per browser session; stamped onto the cart so the order
  // carries its own source. wl-bar.js reads wl_src and adds sid to its pings.
  try {
    var SRC = JSON.parse(localStorage.wl_src || "null");
    if (!SRC || !SRC.sid) {
      var utm = {};
      location.search.slice(1).split("&").forEach(function (p) {
        var kv = p.split("=");
        if (/^utm_(source|medium|campaign)$/.test(kv[0]))
          utm[kv[0].slice(4)] = decodeURIComponent(kv[1] || "").slice(0, 60);
      });
      SRC = { sid: Math.random().toString(36).slice(2, 10) + Date.now().toString(36),
              ref: (document.referrer || "").slice(0, 200),
              lp: (location.pathname + location.search).slice(0, 200),
              utm: utm, t: Date.now() };
      localStorage.wl_src = JSON.stringify(SRC);
    }
    if (!sessionStorage.wl_visit_sent) {
      sessionStorage.wl_visit_sent = "1";
      fetch(API + "/api/clog", { method: "POST", keepalive: true,
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ step: "visit", sid: SRC.sid, ref: SRC.ref,
          lp: SRC.lp, utm: (SRC.utm && SRC.utm.source) || "",
          ref_now: (document.referrer || "").slice(0, 200),
          pg: (location.pathname + location.search).slice(0, 160) }) })
        .catch(function () {});
    }
    // Stamp the source onto the cart ONCE so it rides to the Shopify order as
    // note attributes — the order then names its source, no guesswork. Only
    // when a cart cookie exists; retries next pageview until stamped.
    if (SRC.sid && !sessionStorage.wl_src_stamped &&
        /(^|; )cart=/.test(document.cookie)) {
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (!c || !c.item_count) return;
          if (c.attributes && c.attributes.wl_sid) {
            sessionStorage.wl_src_stamped = "1"; return; }
          var first = [SRC.ref || "-", SRC.lp || "-",
            (SRC.utm && SRC.utm.source) ? "utm:" + SRC.utm.source : "-"]
            .join(" | ").slice(0, 250);
          return fetch("/cart/update.js", { method: "POST",
            credentials: "same-origin",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ attributes:
              { wl_sid: SRC.sid, wl_first: first } })
          }).then(function () { sessionStorage.wl_src_stamped = "1"; });
        }).catch(function () {});
    }
  } catch (e) {}
  var GROUPS = [["artwork", "Artworks"], ["tool", "Studio tools"],
    ["collection", "Collections"], ["page", "Pages & services"],
    ["policy", "Pages & services"], ["faq", "Help & guides"],
    ["article", "Journal"]];
  var ORDER = ["Artworks", "Studio tools", "Collections", "Pages & services",
    "Help & guides", "Journal"];

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  // bold the typed words inside a result title — the one Google flourish
  function mark(title, q) {
    var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; })
      .sort(function (a, b) { return b.length - a.length; })
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); });
    var out = esc(title);
    if (!words.length) return out;
    // single alternation pass — replace() never rescans the inserted <b> tags
    return out.replace(new RegExp("(" + words.join("|") + ")", "ig"), "<b>$1</b>");
  }

  function ready(fn) { document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", fn) : fn(); }

  ready(function () {
    document.querySelectorAll("header-search").forEach(function (hs) { boot(hs); });
  });

  function boot(hs) {
    var form = hs.querySelector("form");
    var input = hs.querySelector('input[type="search"], input[name="q"]');
    var panel = hs.querySelector(".wl-sitesearch");
    if (!form || !input || !panel || panel.dataset.wlDone) return;
    panel.dataset.wlDone = "1";

    var css = document.createElement("style");
    css.textContent =
      ".wl-sitesearch{max-height:min(70vh,640px);overflow-y:auto;overscroll-behavior:contain}" +
      ".wl-ss-group{padding:14px 0 4px}" +
      ".wl-ss-head{margin:0 0 8px;letter-spacing:.08em;text-transform:uppercase;font-size:.6875rem;opacity:.55}" +
      ".wl-ss-row{display:flex;align-items:center;gap:12px;padding:7px 10px;border-radius:8px;text-decoration:none;color:inherit}" +
      ".wl-ss-row:hover,.wl-ss-row.is-active{background:rgba(0,0,0,.05)}" +
      ".wl-ss-row img{width:44px;height:44px;object-fit:cover;border-radius:4px;flex:none}" +
      ".wl-ss-t{font-size:.9375rem;line-height:1.35}" +
      ".wl-ss-s{font-size:.8125rem;opacity:.6;line-height:1.35;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden}" +
      ".wl-ss-price{margin-left:auto;font-size:.8125rem;opacity:.65;flex:none}" +
      ".wl-ss-all{display:inline-block;margin:6px 10px 12px;font-size:.875rem;text-decoration:underline;text-underline-offset:3px;color:inherit}" +
      ".wl-ss-foot{padding:10px;font-size:.75rem;opacity:.5}" +
      ".wl-ss-closest{margin:0 10px 6px;font-size:.8125rem;opacity:.6}" +
      ".wl-ss-empty{padding:18px 10px;font-size:.9375rem;opacity:.7}" +
      ".wl-ss-srcline{margin:4px 10px 12px;font-size:.875rem;opacity:.8}" +
      ".wl-ss-srcline button{font:inherit;background:none;border:none;padding:0;color:inherit;" +
      "text-decoration:underline;text-underline-offset:3px;cursor:pointer}" +
      // Source popup — built from the WL design tokens (wl_tokens.css /
      // DESIGN-RULES.md, Summer 2026-09-02): Fraunces 400 section title,
      // Montserrat everything else, olive #425934 + hairline #dddddd + ink
      // #1c1c1c only, radius 0, 44px primary / 40px input heights
      "#wlsrcov{position:fixed;inset:0;z-index:2147482900;background:rgba(20,20,20,.55);" +
      "display:none;align-items:flex-end;justify-content:center}" +
      "@media(min-width:700px){#wlsrcov{align-items:center}}" +
      "#wlsrcpop{position:relative;background:#fff;color:#1c1c1c;width:min(520px,100%);max-height:92vh;overflow:auto;" +
      "padding:24px;font-family:'Montserrat',-apple-system,sans-serif}" +
      "#wlsrcpop h3{font:400 22px/1.25 'Fraunces',Georgia,serif;color:#1c1c1c;margin:0 0 8px}" +
      "#wlsrcpop .wl-src-x2{position:absolute;top:10px;right:10px;width:44px;height:44px;border:none;" +
      "background:none;color:#1c1c1c;font-size:18px;line-height:1;cursor:pointer;padding:0}" +
      "#wlsrcpop .wl-src-mt{display:none;font:700 15px/1.5 'Montserrat',-apple-system,sans-serif;" +
      "color:#425934;margin:0 0 12px}" +
      "#wlsrcpop .wl-src-row{display:flex;align-items:center;gap:10px;margin:0 0 10px}" +
      "#wlsrcpop .wl-src-att{height:40px;border:1px solid #dddddd;border-radius:0;background:#fff;color:#1c1c1c;" +
      "padding:0 14px;font:400 12px 'Montserrat',-apple-system,sans-serif;cursor:pointer;white-space:nowrap}" +
      "#wlsrcpop .wl-src-thumb{width:40px;height:40px;object-fit:cover;border:1px solid #dddddd;flex:none}" +
      "#wlsrcpop .wl-src-attname{font:400 12px 'Montserrat',-apple-system,sans-serif;" +
      "color:rgba(28,28,28,.65);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0}" +
      "#wlsrcpop .d{font:400 14px/1.6 'Montserrat',-apple-system,sans-serif;color:rgba(28,28,28,.65);margin:0 0 14px}" +
      "#wlsrcpop .d strong{color:#1c1c1c}" +
      "#wlsrcpop textarea,#wlsrcpop input[type=email],#wlsrcpop input[type=url]{width:100%;box-sizing:border-box;" +
      "margin:0 0 10px;padding:10px 12px;font:400 14px/1.5 'Montserrat',-apple-system,sans-serif;" +
      "border:1px solid #dddddd;border-radius:0;background:#fff;color:#1c1c1c}" +
      "#wlsrcpop input[type=email],#wlsrcpop input[type=url]{height:40px}" +
      "#wlsrcpop .foot{display:flex;gap:16px;align-items:center;margin-top:8px}" +
      "#wlsrcpop .btn{height:44px;background:#425934;color:#fff;border:none;border-radius:0;padding:0 22px;" +
      "font:600 12.5px/1 'Montserrat',-apple-system,sans-serif;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}" +
      "#wlsrcpop .btn:disabled{opacity:.5;cursor:default}" +
      "#wlsrcpop .lnk{background:none;border:none;color:#425934;text-decoration:underline;cursor:pointer;" +
      "font:400 12px 'Montserrat',-apple-system,sans-serif}" +
      "#wlsrcpop .msg{font:400 12px/1.5 'Montserrat',-apple-system,sans-serif;color:rgba(28,28,28,.65);margin:10px 0 0}" +
      "@media (max-width:699px){.wl-sitesearch{max-height:calc(100dvh - 140px)}.wl-ss-row img{width:40px;height:40px}}";
    // inline copy of the popup rules for the finding page form (#wlsrcinline)
    css.textContent += (css.textContent.match(/#wlsrcpop[^}]*\}/g) || []).join("").replace(/#wlsrcpop/g, "#wlsrcinline") +
      "#wlsrcinline{max-height:none;overflow:visible;width:100%;max-width:620px;border:1px solid #dddddd;margin:6px 0 10px}" +
      "#wlsrcinline h3{display:none}";   // the page H1 already names it
    panel.appendChild(css);
    var box = document.createElement("div");
    panel.appendChild(box);

    var ctl = null, timer = null, deepTimer = null, active = -1,
        lastQ = "", lastMode = "", lastN = 0;

    function rows() { return box.querySelectorAll(".wl-ss-row"); }

    function render(d, q, deepRan) {
      var groups = {};
      (d.artworks || []).forEach(function (a) { (groups.Artworks = groups.Artworks || []).push(a); });
      (d.docs || []).forEach(function (doc) {
        for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i][0] === doc.type) {
          (groups[GROUPS[i][1]] = groups[GROUPS[i][1]] || []).push(doc); return; }
      });
      // group order: federated, Google-style — each group ranks by its best
      // item's score, so a shipping query shows the shipping answer first, not
      // six vibe-matched canvases. One override: a real artwork NAME/index hit
      // (score >= 1.75) always leads. Ties fall back to the canonical ORDER.
      var awTop = (d.artworks && d.artworks[0] && d.artworks[0].score) || 0;
      var order = ORDER.map(function (g, i) {
        var best = 0;
        (groups[g] || []).forEach(function (it) { if ((it.score || 0) > best) best = it.score; });
        return { g: g, best: best, i: i };
      }).filter(function (x) { return groups[x.g] && groups[x.g].length; })
        .sort(function (a, b) { return b.best - a.best || a.i - b.i; })
        .map(function (x) { return x.g; });
      if (awTop >= 1.75 && order.indexOf("Artworks") > 0)
        order.splice(0, 0, order.splice(order.indexOf("Artworks"), 1)[0]);
      var h = "";
      // several works can share one display name ("Water Lilies" x4) — when that
      // happens, each colliding row also shows its title's descriptor segment
      // ("Panoramic Green Blue…") so shoppers can tell them apart before clicking
      var nameN = {};
      (groups.Artworks || []).slice(0, 6).forEach(function (a) {
        var k = (a.name || a.title) + "|" + (a.artist || "");
        nameN[k] = (nameN[k] || 0) + 1;
      });
      function subLine(it) {
        var nm = (it.name || "").trim().toLowerCase(),
            ar = (it.artist || "").trim().toLowerCase();
        var segs = String(it.title || "").split("|").map(function (s) { return s.trim(); })
          .filter(function (s) { var l = s.toLowerCase(); return s && l !== nm && l !== ar; });
        return segs.join(" · ");
      }
      order.forEach(function (g) {
        var items = groups[g]; if (!items || !items.length) return;
        h += '<div class="wl-ss-group"><p class="wl-ss-head">' + g + "</p>";
        // closest-match label (Summer 2026-09-01): the worker sets closest=true
        // when nothing matched by name/word and even semantic scores are weak —
        // results still show, but honestly labelled
        if (g === "Artworks" && d.closest)
          h += '<p class="wl-ss-closest">No exact match — closest artworks to your search</p>';
        items.slice(0, g === "Artworks" ? 6 : 5).forEach(function (it) {
          if (g === "Artworks") {
            var dup = nameN[(it.name || it.title) + "|" + (it.artist || "")] > 1, sub = dup ? subLine(it) : "";
            h += '<a class="wl-ss-row" href="' + esc(it.url) + '">' +
              (it.image ? '<img loading="lazy" src="' + esc(it.image +
                (it.image.indexOf("cdn.shopify.com") > -1
                  ? (it.image.indexOf("?") > -1 ? "&width=88" : "?width=88") : "")) + '" alt="">' : "") +
              "<span>" +
              '<span class="wl-ss-t">' + mark(it.name || it.title.split("|")[0].trim(), q) +
              (it.artist ? ' <span style="opacity:.6">· ' + esc(it.artist) + "</span>" : "") + "</span>" +
              (sub ? '<span class="wl-ss-s">' + esc(sub) + "</span>" : "") + "</span>" +
              (it.price_min ? '<span class="wl-ss-price">from $' + Math.round(+it.price_min) + "</span>" : "") + "</a>";
          } else {
            h += '<a class="wl-ss-row" href="' + esc(it.url) + '"><span>' +
              '<span class="wl-ss-t">' + mark(it.title, q) + "</span>" +
              (it.snip ? '<span class="wl-ss-s">' + esc(it.snip) + "</span>" : "") + "</span></a>";
          }
        });
        if (g === "Artworks")
          h += '<a class="wl-ss-all" href="/collections/all?wlq=' + encodeURIComponent(q) +
            '">See all artwork matches →</a>';
        h += "</div>";
      });
      if (!h) h = '<p class="wl-ss-empty">No matches for “' + esc(q) +
        '” — try the <a href="/collections/all" style="color:inherit">Art Search</a>' +
        ' or browse <a href="/pages/artists" style="color:inherit">our artists</a>' +
        (deepRan ? "" : ", or press Enter for a smarter look") + ".</p>" +
        (deepRan ? srcLine() : "");
      else if (!deepRan) h += '<p class="wl-ss-foot">Press Enter ↵ for a smarter search of everything</p>';
      // personal sourcing offer (Summer 2026-09-02, redesigned same day): when
      // the search could not find the real thing — weak closest-matches or
      // nothing at all — ONE quiet line opens the Source popup. Never a form
      // injected into the results (Summer: "very irresponsible design").
      if (h && d.closest && h.indexOf("wl-ss-srcline") < 0) h += srcLine();
      box.innerHTML = h;
      active = -1;
    }

    function srcLine() {
      return '<p class="wl-ss-srcline">Can’t find it? ' +
        '<button type="button" class="wl-ss-srcgo">We’ll find it for you, free</button></p>';
    }

    // ---- Source popup (Summer 2026-09-02) -----------------------------------
    // ONE popup for the whole site: opened by the art page's Source button, by
    // the failed-search lines here and in wl_bar.js. Lives on document.body so
    // it works with the dropdown closed. Sends to /api/art-request.
    // ONE form, two homes (Summer 2026-09-17): the popup (search bar, hero,
    // failed-search lines) and INLINE on /pages/service-curation, where the
    // page body carries <div id="wl-find-art-form"></div>. Same fields, same send.
    function srcMarkup(inline) {
      return (inline ? "" : '<button type="button" class="wl-src-x2" aria-label="Close">✕</button>') +
        '<p class="wl-src-mt"></p>' +
        '<h3>Find an artwork, free</h3>' +
        '<p class="d">Send the artist, the title or a picture. A web link or a screenshot is fine, even low resolution. Summer replies within 1–3 days. Free service, limited to 30 requests a month.</p>' +
        '<textarea rows="3" class="wl-src-q" placeholder="Artist, title, or describe the artwork"></textarea>' +
        '<div class="wl-src-row"><button type="button" class="wl-src-att">Add a picture (low resolution is fine)</button>' +
        '<img class="wl-src-thumb" alt="Your picture" style="display:none">' +
        '<span class="wl-src-attname"></span></div>' +
        '<input class="wl-src-l" type="url" placeholder="Or paste a link to the picture">' +
        '<input class="wl-src-e" type="email" placeholder="Your email" autocomplete="email">' +
        '<input class="wl-src-hp" type="text" tabindex="-1" autocomplete="off" style="position:absolute;left:-9999px" aria-hidden="true">' +
        '<div class="foot"><button type="button" class="btn wl-src-b">Find my artwork</button></div>' +
        '<p class="msg wl-src-m"></p>';
    }

    function srcBind(root) {
      root.querySelector(".wl-src-b").addEventListener("click", function () { srcSend(root); });
      // picture attach — up to 3 MB, kept as a data URI until send
      root.querySelector(".wl-src-att").addEventListener("click", function () {
        var fi = document.createElement("input"); fi.type = "file"; fi.accept = "image/*";
        fi.onchange = function () {
          var f = fi.files[0]; if (!f) return;
          var nm = root.querySelector(".wl-src-attname"), th = root.querySelector(".wl-src-thumb");
          if (f.size > 3 * 1024 * 1024) { root._img = null; th.style.display = "none"; nm.textContent = "Pictures up to 3 MB, please."; return; }
          var rd = new FileReader();
          // small thumbnail beside the button once a picture is chosen (Summer 2026-09-17)
          rd.onload = function () { root._img = rd.result; root._imgName = f.name; nm.textContent = f.name;
            th.src = rd.result; th.style.display = "block"; };
          rd.readAsDataURL(f);
        };
        fi.click();
      });
    }

    function srcPop() {
      var ov = document.getElementById("wlsrcov");
      if (ov) return ov;
      ov = document.createElement("div");
      ov.id = "wlsrcov";
      ov.innerHTML = '<div id="wlsrcpop">' + srcMarkup(false) + '</div>';
      document.body.appendChild(ov);
      ov.addEventListener("click", function (e) { if (e.target === ov) ov.style.display = "none"; });
      ov.querySelector(".wl-src-x2").addEventListener("click", function () { ov.style.display = "none"; });
      srcBind(ov);
      return ov;
    }

    // inline form on the finding page — mounted once
    var srcSlot = document.getElementById("wl-find-art-form");
    if (srcSlot && !srcSlot.dataset.wlDone) {
      srcSlot.dataset.wlDone = "1";
      srcSlot.innerHTML = '<div id="wlsrcinline">' + srcMarkup(true) + '</div>';
      srcBind(srcSlot);
    }

    function srcOpen(q) {
      var ov = srcPop();
      var qEl = ov.querySelector(".wl-src-q"), eEl = ov.querySelector(".wl-src-e");
      qEl.disabled = eEl.disabled = false;
      ov.querySelector(".wl-src-l").disabled = false;
      ov.querySelector(".wl-src-b").disabled = false;
      ov.querySelector(".wl-src-m").textContent = "";
      var mt = ov.querySelector(".wl-src-mt");
      mt.textContent = ""; mt.style.display = "none";
      if (q && !qEl.value) qEl.value = q;    // pre-fill, never clobber a draft
      ov.style.display = "flex";
      try { qEl.focus(); } catch (e) {}
    }

    function srcSend(root) {
      var ov = root;
      var qEl = ov.querySelector(".wl-src-q"), eEl = ov.querySelector(".wl-src-e");
      var lEl = ov.querySelector(".wl-src-l");
      var btn = ov.querySelector(".wl-src-b"), msg = ov.querySelector(".wl-src-m");
      var qv = (qEl.value || "").trim(), em = (eEl.value || "").trim();
      var lk = (lEl.value || "").trim();
      if (qv.length < 3 && !ov._img && !lk) {
        msg.textContent = "Add the artist, the title or a picture."; return;
      }
      if (!/@.+\./.test(em)) {
        msg.textContent = "Add your email so Summer can reply."; return;
      }
      if (lk && !/^https?:\/\//i.test(lk)) lk = "https://" + lk;
      btn.disabled = true;
      fetch(API + "/api/art-request", { method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ q: qv, email: em, hp: ov.querySelector(".wl-src-hp").value,
          searched: lastQ, page: location.pathname,
          link: lk.slice(0, 300), img: ov._img || "", imgName: ov._imgName || "" }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.ok) {
            // sent confirmation at the TOP — bold, dark green (Summer 2026-09-02)
            var mt = ov.querySelector(".wl-src-mt");
            mt.textContent = d.message || "Sent. Summer will email you within 1–3 days.";
            mt.style.display = "block";
            var pop = ov.querySelector("#wlsrcpop"); if (pop) pop.scrollTop = 0;
            msg.textContent = "";
            qEl.disabled = eEl.disabled = lEl.disabled = true;
          } else { msg.textContent = d.message || "Could not send."; btn.disabled = false; }
        })
        .catch(function () {
          msg.textContent = "Could not send — please email summer@wallliberation.com.au.";
          btn.disabled = false;
        });
    }
    // site-wide handle — wl_bar.js (Find art button + failed-search line) uses this
    window.WLAsk = { open: srcOpen };
    // links to #find-art (Summer 2026-09-17): on the finding page they go to the
    // inline form; anywhere else they open the popup
    document.addEventListener("click", function (ev) {
      var a = ev.target && ev.target.closest && ev.target.closest('a[href="#find-art"]');
      if (!a) return;
      ev.preventDefault();
      var inl = document.getElementById("wlsrcinline");
      if (inl) {
        inl.scrollIntoView({ behavior: "smooth", block: "center" });
        try { inl.querySelector(".wl-src-q").focus({ preventScroll: true }); } catch (e) {}
      } else srcOpen("");
    });

    // ---- front-page hero search hooks (Summer 2026-09-02) -------------------
    // wl_bar.js never boots on the home template, so the hero's buttons are
    // wired HERE (this file loads site-wide). The camera used to navigate to
    // the catalogue with ?wlcam=1 and open the picker on arrival — phones
    // refuse a file picker without a user gesture, so it silently did nothing.
    // Now the picker opens ON the front page; the results ride the same
    // localStorage handoff wl_bar's own portalGo/restore path already reads.
    var hcam = document.querySelector(".wlhp .hero-search .cam");
    if (hcam) hcam.addEventListener("click", function (ev) {
      ev.preventDefault();
      var hi = document.querySelector(".wlhp .hero-search input[name=wlq]");
      var inp = document.createElement("input"); inp.type = "file"; inp.accept = "image/*";
      inp.onchange = function () {
        var f = inp.files[0]; if (!f) return;
        if (f.size > 5 * 1024 * 1024) {
          if (hi) { hi.value = ""; hi.placeholder = "Pictures up to 5 MB, please."; } return;
        }
        if (hi) { hi.value = ""; hi.placeholder = "Reading your picture — searching the collection…"; }
        var rd = new FileReader();
        rd.onload = function () {
          fetch(API + "/api/image-search", { method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ image: rd.result }) })
            .then(function (r) { return r.json(); })
            .then(function (r) {
              if (!r.ok) { if (hi) hi.placeholder = r.message || "Could not read that picture."; return; }
              try {
                localStorage.wl_last_search = JSON.stringify({ url: "/collections/all", y: 0,
                  t: Date.now(), q: "", chip: { colours: [] },
                  results: (r.results || []).map(function (c) { return c.index; }).slice(0, 60) });
                localStorage.wl_restore = "1";
              } catch (e) {}
              location.href = "/collections/all";
            })
            .catch(function () { if (hi) hi.placeholder = "The search had a hiccup — try again."; });
        };
        rd.readAsDataURL(f);
      };
      inp.click();
    });
    var hsrc = document.getElementById("wlhero-src");
    if (hsrc) hsrc.onclick = function () {
      var hi = document.querySelector(".wlhp .hero-search input[name=wlq]");
      srcOpen(((hi && hi.value) || "").trim());
    };

    function run(deep) {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(deepTimer);
      if (!q) { box.innerHTML = ""; lastMode = ""; lastN = 0; return; }
      if (ctl) ctl.abort();
      ctl = ("AbortController" in window) ? new AbortController() : null;
      fetch(API + "/api/site-search", { method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(deep ? { q: q, deep: true } : { q: q }),
        signal: ctl && ctl.signal })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
        .then(function (d) { if (q === lastQ) {
          lastMode = d.mode || "";
          lastN = (d.artworks || []).length + (d.docs || []).length;
          // the worker's own words when it must rest (daily cap) — never a blank
          // "No matches" for a shopper who did nothing wrong (2026-09-10)
          if (d.message && !lastN) { box.innerHTML = '<p class="wl-ss-empty">' + esc(d.message) + "</p>"; return; }
          render(d, q, d.mode === "deep" || !!deep);
          // auto-deep (Summer 2026-09-01: "calm large blue art for a bedroom"
          // must never come back empty): when the instant tier is thin and the
          // visitor pauses typing, the smart tier runs by itself — Enter no
          // longer required. 700 ms of quiet before the (paid) embedding call;
          // any further keystroke cancels it.
          // never auto-deepen an exact index lookup (score 9) — "2335n" has
          // its answer; semantic extras after it are noise + a wasted call
          // 2026-09-10: only when THIS call was the instant tier (deep not asked for).
          // A deep call the worker refused or downgraded answered mode "lex" too, and
          // the old test re-armed itself every 700 ms for ever. Also: any script
          // (Chinese, Greek, Cyrillic…) may deepen — the instant tier only knows a-z.
          if (!deep && d.mode !== "deep" && (d.artworks || []).length < 4 &&
              !((d.artworks || [])[0] && d.artworks[0].score >= 9) &&
              /[\p{L}\p{N}]{2,}/u.test(q)) {
            deepTimer = setTimeout(function () {
              if (q === input.value.trim()) run(true);
            }, 700);
          }
        } })
        .catch(function (e) { if (e && e.name !== "AbortError") {
          // one quiet retry (a dropped connection, a 5xx blip), then say so plainly
          if (!retried) { retried = true; setTimeout(function () { if (q === input.value.trim()) run(deep); }, 900); return; }
          box.innerHTML = '<p class="wl-ss-empty">The search did not answer — <button type="button" class="wl-ss-retry" style="font:inherit;text-decoration:underline;background:none;border:0;color:inherit;cursor:pointer">try again</button></p>';
          var rb = box.querySelector(".wl-ss-retry"); if (rb) rb.onclick = function () { retried = false; run(deep); };
          try { fetch(API + "/api/clog", { method: "POST", keepalive: true, headers: { "content-type": "application/json" },
            body: JSON.stringify({ step: "search-error", q: q.slice(0, 120), err: String(e && e.message || e).slice(0, 80) }) }); } catch (e2) {}
        } });
    }
    var retried = false;

    // click pulse (2026-08-12): which result a query actually won — lets
    // /wl-pulse spot queries that return results nobody clicks (relevance
    // failures) . keepalive so the beacon survives the navigation it triggers
    function clickPulse(href) {
      try { fetch(API + "/api/clog", { method: "POST", keepalive: true,
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ step: "search-click", q: lastQ.slice(0, 120),
          url: String(href || "").slice(0, 180), mode: lastMode, n: lastN }) }); } catch (e) {}
    }
    // every anchor in the box is a result row, the see-all link, or an
    // empty-state recovery link — log them all (2026-08-20; the old
    // class-scoped selector missed the recovery links). auxclick covers
    // middle-click open-in-new-tab, which "click" never fires for.
    function pulseFromEvent(ev) {
      var row = ev.target && ev.target.closest && ev.target.closest("a");
      if (row && box.contains(row)) clickPulse(row.getAttribute("href"));
    }
    box.addEventListener("click", function (ev) {
      var srcBtn = ev.target && ev.target.closest && ev.target.closest(".wl-ss-srcgo");
      if (srcBtn) { ev.preventDefault(); srcOpen(lastQ); return; }
      pulseFromEvent(ev);
    });
    box.addEventListener("auxclick", function (ev) { if (ev.button === 1) pulseFromEvent(ev); });
    input.addEventListener("input", function () {
      clearTimeout(timer);
      clearTimeout(deepTimer);
      retried = false;
      timer = setTimeout(function () { run(false); }, 220);
    });
    form.addEventListener("submit", function (ev) {
      // Enter without a highlighted row = deep search in place. The form's
      // native action (/search, Shopify results) stays as the no-JS fallback.
      ev.preventDefault();
      var rs = rows();
      if (active >= 0 && rs[active]) { clickPulse(rs[active].getAttribute("href")); location.href = rs[active].href; return; }
      clearTimeout(timer);
      run(true);
    });
    input.addEventListener("keydown", function (ev) {
      // the theme's dialog component swallows implicit form submission, so
      // Enter is handled here directly (submit listener stays as a fallback)
      if (ev.key === "Enter") {
        ev.preventDefault();
        var rsE = rows();
        if (active >= 0 && rsE[active]) { clickPulse(rsE[active].getAttribute("href")); location.href = rsE[active].href; return; }
        clearTimeout(timer);
        run(true);
        return;
      }
      var rs = rows(); if (!rs.length) return;
      if (ev.key === "ArrowDown" || ev.key === "ArrowUp") {
        ev.preventDefault();
        active = ev.key === "ArrowDown"
          ? (active + 1) % rs.length : (active - 1 + rs.length) % rs.length;
        rs.forEach(function (r, i) { r.classList.toggle("is-active", i === active); });
        rs[active].scrollIntoView({ block: "nearest" });
      }
    });
  }

  /* ---- header cart badge (Summer 2026-07-31) --------------------------------
     The olive numbered badge is styled in wl-overrides.css, but <cart-dot> is a
     theme element carrying no count, so a script has to write the number in.
     That writer started in wl_bar.js — which only loads on artwork pages, so the
     homepage rendered the styled circle with nothing in it: a bare green dot.
     The header is on EVERY page and so is this module (injected in
     snippets/header-search.liquid), which makes this its correct home.
     wl_bar.js now only fires cart:refresh after a native add; the write is here. */
  var ccAt = 0;
  function cartBadge() {
    var now = Date.now();
    if (now - ccAt < 400) return;            // add-to-cart flows fire in bursts
    ccAt = now;
    fetch("/cart.js", { cache: "no-store" }).then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        Array.prototype.forEach.call(document.querySelectorAll(".header__cart-dot"),
          function (d) {
            d.textContent = n > 99 ? "99+" : (n ? String(n) : "");
            d.classList.toggle("is-visible", n > 0);
          });
      }).catch(function () {});
  }
  ["cart:refresh", "cart:change"].forEach(function (ev) {
    document.documentElement.addEventListener(ev, function () { setTimeout(cartBadge, 150); });
  });
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", cartBadge);
  else cartBadge();
})();

// ---- Enhancement PDP layout (Summer 2026-08-23; lives here because
// wl-search loads on EVERY page incl. this PDP — wl-bar does not) -----------
(function () {
  function boot() {
    // ONE height applier per page (Summer 2026-08-24) — see wl_customiser.js.
    // All three of customiser/search/bar load on the print page and each used to
    // run its own copy of this on every beat. First one in wires it.
    if (!window.__wlEnhHWired) {
      window.__wlEnhHWired = 1;
      window.addEventListener("message", function (e) {
        var d = e && e.data;
        if (!d || !d.wlEnhH) return;
        document.querySelectorAll('iframe[src*="enhance-widget"]').forEach(function (f) {
          if (f.contentWindow !== e.source) return;
          var before = f.getBoundingClientRect(), oldH = before.height;
          // 90 is the floor for a viewer pane (a shorter box left dead space).
          // The upload pane is one button plus a line of formats — hold it to
          // its real height or it carries ~30px of white under the button.
          var up = /pane=up/.test(f.getAttribute("src") || "");
          var newH = Math.max(up ? 44 : 90, Math.min(1400, +d.wlEnhH + 8));
          if (Math.abs(newH - oldH) < 1) return;    // unchanged — don't touch the DOM
          f.style.height = newH + "px";
          // keep the visitor's view anchored through a height change above
          // the fold — see wl_customiser.js for the root cause (2026-08-24)
          if (before.top < 0) window.scrollTo(0, window.scrollY + (newH - oldH));
        });
      });
    }
    if (location.pathname.indexOf("/products/image-enhancement-300-dpi-print-master") !== 0) return;
    // Summer 2026-08-24 r6 — this page is now the twin of the print page.
    //   LEFT  (grid-area product-gallery)  #wlenhsec  = the preview, ?pane=view
    //   LEFT  (grid-area product-content)  the description, native theme block
    //   RIGHT (product-info)               #wlenhup   = the upload zone, ?pane=up
    // Both divs ship inside the product description, so Summer can edit the
    // copy around them without touching this file.
    var hideCss = document.createElement("style");
    hideCss.textContent = "#wlenhsec:not(.wlseated),#wlenhup:not(.wlseated){visibility:hidden}";
    document.head.appendChild(hideCss);
    var styled = false;
    // The theme goes two-column at 1000px (main-product.liquid), so that is the
    // line this follows too — not the 750px the print page uses internally.
    var MQ = window.matchMedia("(max-width:999px)");

    function buyItem() {
      var f = document.querySelector('.product-info form[action*="/cart/add"]');
      return f ? f.closest(".product-info__block-item") : null;
    }

    // The upload zone sits ABOVE Add to cart at every width: pick your file,
    // then buy. Same reading order as the print page.
    function seatUp() {
      var up = document.getElementById("wlenhup"), buy = buyItem();
      if (!(up && buy && buy.parentElement)) return false;
      up.classList.add("product-info__block-item");
      if (up.nextElementSibling !== buy) buy.parentElement.insertBefore(up, buy);
      up.classList.add("wlseated");
      return true;
    }

    // Desktop: the preview claims the gallery's grid slot (the native gallery is
    // hidden, its media stays on the product for the SEO alts).
    // Mobile: the grid runs gallery -> info -> content, so leaving the preview in
    // the gallery slot pushes the title and price off the first screen. It moves
    // in under the upload zone instead, giving title -> price -> upload ->
    // preview -> add to cart -> description.
    function seatView() {
      var sec = document.getElementById("wlenhsec"),
          gal = document.querySelector("product-gallery, .product-gallery");
      if (!sec) return false;
      if (MQ.matches) {
        var up = document.getElementById("wlenhup");
        if (!(up && up.parentElement)) return false;
        if (up.nextElementSibling !== sec)
          up.parentElement.insertBefore(sec, up.nextElementSibling);
      } else {
        if (!(gal && gal.parentElement)) return false;
        if (gal.previousElementSibling !== sec) gal.parentElement.insertBefore(sec, gal);
      }
      sec.classList.add("wlseated");
      if (!styled) {
        styled = true;
        var st = document.createElement("style");
        st.textContent =
          "product-gallery,.product-gallery{display:none!important}" +
          "#wlenhsec{align-self:start;margin:0 0 10px}" +
          "@media(min-width:1000px){#wlenhsec{grid-area:product-gallery}}" +
          "@media(max-width:999px){#wlenhsec{margin:0 0 14px}}";
        document.head.appendChild(st);
      }
      return true;
    }

    var tries = 0, iv = setInterval(function () {
      if ((seatUp() & seatView()) || ++tries > 40) clearInterval(iv);
    }, 250);
    // Crossing the breakpoint re-homes the preview. Guarded by the
    // parent/sibling checks above, so a resize that changes nothing moves
    // nothing — an appendChild would reload the iframe inside it.
    var onMQ = function () { seatUp(); seatView(); };
    if (MQ.addEventListener) MQ.addEventListener("change", onMQ);
    else if (MQ.addListener) MQ.addListener(onMQ);

    // ---- The order must carry the customer's file (Summer 2026-08-25) ------
    // Sold on its own, this product kept no link to the upload at all: Add to
    // cart was live before any file was chosen, and even after a FINISHED
    // preview the cart line came through with properties {} — so every $19
    // order meant emailing the customer to ask which file it was for. The
    // print page has gated on its upload since 2026-07-30; this is that gate.
    // The view pane posts {wlEnhRef:<job>} as soon as a preview is ready and
    // re-posts it on reload for a returning visitor, so the button unblocks on
    // its own — nobody is asked to upload twice.
    var enhRef = null, enhNote = null;
    function buyForm() {
      return document.querySelector('.product-info form[action*="/cart/add"]');
    }
    function buyBtns() {
      var f = buyForm(), out = [];
      if (f) out = [].slice.call(f.querySelectorAll('button[type="submit"],[name="add"]'));
      var sticky = document.querySelector('.product-sticky-bar button[type="submit"]');
      if (sticky) out.push(sticky);
      return out;
    }
    // Shopify only records a line property that is IN the form when it posts,
    // so the ref rides as a hidden input rather than being bolted on at click.
    function stampRef() {
      var f = buyForm();
      if (!f || !enhRef) return;
      var i = f.querySelector('input[name="properties[Your file]"]');
      if (!i) {
        i = document.createElement("input");
        i.type = "hidden";
        i.name = "properties[Your file]";
        f.appendChild(i);
      }
      i.value = enhRef;
    }
    // A dead button answers nothing (same ruling as the print page, 2026-07-30):
    // pointer-events go off while blocked so the click lands on the wrapper and
    // we can scroll to + flash the upload zone instead of doing nothing.
    function nudge() {
      var up = document.getElementById("wlenhup");
      if (!up) return;
      try { up.scrollIntoView({ block: "center", behavior: "smooth" }); } catch (e) { up.scrollIntoView(); }
      up.style.transition = "box-shadow .18s";
      up.style.boxShadow = "0 0 0 3px #425934";
      setTimeout(function () { up.style.boxShadow = ""; }, 900);
    }
    function gate() {
      var ok = !!enhRef, why = "Upload your image to order.";
      buyBtns().forEach(function (b) {
        b.disabled = !ok;
        b.style.opacity = ok ? "" : ".45";
        b.style.pointerEvents = ok ? "" : "none";
        b.title = ok ? "" : why;
        if (!b.__wlEnhNudge && b.parentElement) {
          b.__wlEnhNudge = 1;
          b.parentElement.addEventListener("click", function () {
            if (b.disabled) nudge();
          });
        }
      });
      var f = buyForm();
      if (f && f.parentElement) {
        if (!enhNote) {
          enhNote = document.createElement("p");
          enhNote.className = "wlenh-gate-note";
          enhNote.style.cssText = "margin:6px 0 0;font-size:.86rem;color:#55524a";
        }
        if (!ok) {
          enhNote.textContent = why;
          if (enhNote.parentElement !== f.parentElement) f.parentElement.appendChild(enhNote);
        } else if (enhNote.parentElement) {
          enhNote.parentElement.removeChild(enhNote);
        }
      }
      if (ok) stampRef();
    }
    // The widget posts {wlEnhRef} ONCE, the moment a preview turns ready — a
    // listener that attaches after that fires never hears it, which would leave
    // a returning visitor staring at a locked button. The widget is served from
    // /apps/studio, i.e. same-origin, so read its job id straight out of the
    // iframe and treat the message as a live nudge on top of that. One poll
    // also re-locks on "Try another image", which clears the job — a cleared
    // preview must not be buyable against the previous file.
    function refFromWidget() {
      var out = null;
      document.querySelectorAll('iframe[src*="enhance-widget"]').forEach(function (f) {
        if (out) return;
        try { out = f.contentWindow.localStorage.getItem("wl_enh_job") || null; } catch (e) {}
      });
      return out && /^[\w-]{6,60}$/.test(out) ? out : null;
    }
    window.addEventListener("message", function (e) {
      var d = e && e.data;
      if (!d || !d.wlEnhRef) return;
      if (!/^[\w-]{6,60}$/.test(String(d.wlEnhRef))) return;
      enhRef = String(d.wlEnhRef);
      gate();
    });
    setInterval(function () {
      var r = refFromWidget();
      if (r !== enhRef) { enhRef = r; gate(); }
    }, 1000);
    gate();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
